<div class="backdrop" [class.show]="menuOpen" (click)="closeMenu.emit()"></div>
<aside class="sidebar" [class.open]="menuOpen" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <button
      type="button"
      class="collapse-btn"
      (click)="toggleCollapse()"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!isCollapsed"
    >
      <span class="material-symbols-outlined">{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</span>
    </button>
  </div>

  <nav class="sidebar-nav" aria-label="Main navigation">
    @for (section of sections; track section.title) {
      <div class="nav-section">
        <span class="section-label">{{ section.title }}</span>

        @for (item of section.items; track item.label) {
          @if (item.children && item.children.length > 0) {
            <div class="nav-item-group">
              <a
                class="nav-item parent"
                [class.expanded]="isExpanded(item.label)"
                [class.has-active-child]="hasActiveChild(item)"
                (click)="toggleExpand(item.label, $event)"
                role="button"
                [attr.aria-expanded]="isExpanded(item.label)"
                [attr.aria-label]="item.label"
              >
                <span class="material-symbols-outlined nav-icon">{{ item.icon }}</span>
                <span class="nav-label">{{ item.label }}</span>
                <span class="material-symbols-outlined expand-icon">{{ isExpanded(item.label) ? 'expand_less' : 'expand_more' }}</span>
              </a>
              @if (isExpanded(item.label)) {
                <div class="submenu">
                  @for (child of item.children; track child.label) {
                    <a
                      class="nav-item child"
                      [routerLink]="child.route"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="closeMenu.emit()"
                      [attr.aria-label]="child.label"
                    >
                      <span class="material-symbols-outlined nav-icon">{{ child.icon }}</span>
                      <span class="nav-label">{{ child.label }}</span>
                    </a>
                  }
                </div>
              }
            </div>
          } @else if (item.comingSoon || !item.route) {
            <span class="nav-item disabled" aria-disabled="true" title="Coming soon" [attr.aria-label]="item.label + ' (coming soon)'">
              <span class="material-symbols-outlined nav-icon">{{ item.icon }}</span>
              <span class="nav-label">{{ item.label }}</span>
              <span class="soon-tag">Soon</span>
            </span>
          } @else {
            <a
              class="nav-item"
              [routerLink]="item.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: item.exact ?? item.route === '/dashboard' }"
              (click)="closeMenu.emit()"
              [attr.aria-label]="item.label"
            >
              <span class="material-symbols-outlined nav-icon">{{ item.icon }}</span>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          }
        }
      </div>
    }
  </nav>

  <div class="sidebar-foot">
    <div class="occupancy" title="Bed occupancy: coming soon">
      <span class="ds-label">Occupancy</span>
      <span class="soon-tag">Coming soon</span>
    </div>
  </div>
</aside>
